import { styled } from 'styled-components';
import { Form } from 'antd';
import { blockStyle } from '../../../../../components/styles/Block';
import { tableGridColumns } from './styles';

export const RowBlock = styled.div`
  ${blockStyle}
  display: grid;
  grid-template-columns: ${tableGridColumns};
  gap: 16px;
`;

export const NoCell = styled.div`
  display: flex;
  align-items: center;
`;

export const DeleteButtonCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ResultCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FormItemNoMargin = styled(Form.Item)`
  margin: 0;
`;
